export function StopModal({
  open, onConfirm, onCancel,
}: { open: boolean; onConfirm: () => void; onCancel: () => void }) {
  if (!open) return null;
  return (
    <div className="modal-overlay">
      <div className="panel modal-card">
        <h2 style={{ textTransform: "none", letterSpacing: 0, color: "var(--foreground)", fontSize: "1.15rem" }}>
          Stop trimming?
        </h2>
        <p style={{ marginTop: 6 }}>
          You&rsquo;ll have <b>15 minutes</b> to change your mind and resume the same session.
        </p>
        <div className="warn-box">
          Don&rsquo;t leave buds exposed or out of the bag while you&rsquo;re finishing up — bag everything
          before you walk away.
        </div>
        <div className="btn-row" style={{ marginTop: 14 }}>
          <button type="button" className="btn btn-ghost" onClick={onCancel}>Keep trimming</button>
          <button type="button" className="btn btn-stop" data-testid="confirm-stop" onClick={onConfirm}>Stop</button>
        </div>
      </div>
    </div>
  );
}
